import http from "../http-common";

class BookSale {
  getAllBookSale() {
    return http.get("/book-sale");
  }
}

export default new BookSale();
